import { graphql, useStaticQuery } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import React, { FC } from "react"
import Item, { Props as ItemProps } from "../molecules/goodsList/Item"
import classes from "./GoodsList.module.scss"

const items: (Omit<ItemProps, "image"> & { image: string })[] = [
  {
    title: {
      ja: "JMoFオリジナル腕時計（限定7個）",
      en: "JMoF Original Wristwatch (limited to 7 pcs)",
    },
    description: {
      ja: (
        <>
          <p>
            JMoF 10周年を記念して製作された、数量限定のプレミアム商品！
            <br />
            タイムカプセル風ケースに入った今回だけの豪華オリジナル腕時計セット。
          </p>
        </>
      ),
      en: (
        <>
          <p>
            A premium product produced in limited quantity to commemorate JMoF’s
            10th anniversary!
            <br />
            This gorgeous original wristwatch set comes in a time capsule-style
            case.
          </p>
        </>
      ),
    },
    price: 77000,
    image: "JMF23_RG_goods_1.png",
  },
  {
    title: {
      ja: "JMoF 2023 タブレットポーチ",
      en: "JMoF 2023 Tablet Pouch",
    },
    description: {
      ja: (
        <>
          <p>
            タブレットやノートPCを収納できるポーチが登場！
            <br />
            イカしたデザインのポーチを持ち歩いてライバルに差を付けろ！
          </p>
          <p>サイズ：W340 × H240 × ［マチ］20 mm</p>
        </>
      ),
      en: (
        <>
          <p>
            Get the original JMoF pouch for your tablet or laptop and stand out
            from the crowd!
          </p>
          <p>Size: W340 x H240 x [Notch] 20 mm</p>
        </>
      ),
    },
    price: 3500,
    image: "JMF23_RG_goods_2.png",
  },
  {
    title: {
      ja: "クラシック棒",
      en: "Classic Hotel Keychain",
    },
    description: {
      ja: (
        <>
          <p>
            レトロなルームキーホルダーが満を持して登場。ナウなヤングにバカウケ間違いなし。
            <br />
            もちろん象が踏んでも壊れません。
          </p>
          <p>サイズ：W180 × H20 × D15 mm</p>
        </>
      ),
      en: (
        <>
          <p>
            Impress your heart still remains in the golden age with a cool room
            keychain in classic retro design!
            <br />
            We promise, it won’t break even if an elephant steps on it.
          </p>
          <p>Size: W180 x H20 x D15 mm</p>
        </>
      ),
    },
    price: 2500,
    image: "JMF23_RG_goods_3.png",
  },
  {
    title: {
      ja: "JMoF 2023 公式Tシャツ",
      en: "JMoF 2023 Official T-shirt",
    },
    description: {
      ja: (
        <>
          <p>
            今回の公式Tシャツは“Back to the
            JMoF”のタイプロゴを大胆にあしらったスタイリッシュなデザイン！
            <br />
            JMoF参加の記念品といえば欠かせない定番アイテム。現地に来れない方へのお土産にもどうぞ。
          </p>
          <p>サイズ：S/M/L/XL/XXL/XXXL</p>
        </>
      ),
      en: (
        <>
          <p>
            Our official T-shirt features the Back to the JMoF logo in a stylish
            design!
            <br />
            This is the perfect souvenir to get as a JMoF participant, but also
            a great gift for those who can’t make it to the event.
          </p>
          <p>Sizes: S/M/L/XL/XXL/XXXL</p>
        </>
      ),
    },
    price: 2500,
    image: "JMF23_RG_goods_4.png",
  },
  {
    title: {
      ja: "JMoF 2023 バンダナ",
      en: "JMoF 2023 Bandana",
    },
    description: {
      ja: (
        <>
          <p>
            壁に飾ってもヨシ！ お弁当を包んでもヨシ！ 頭に巻いてもヨシ！
            使い方はアナタ次第、無限の可能性を秘めた一品。
          </p>
          <p>サイズ：W52 × H52 cm</p>
        </>
      ),
      en: (
        <>
          <p>
            Need a new tapestry? A lunch box wrapper? Something to put around
            your head? You won’t find a more versatile bandana like this one
            anywhere else!
          </p>
          <p>Size: W52 x H52 cm</p>
        </>
      ),
    },
    price: 1600,
    image: "JMF23_RG_goods_5.png",
  },
  {
    title: {
      ja: "JMoF 2023 トートバッグ",
      en: "JMoF 2023 Tote Bag",
    },
    description: {
      ja: (
        <>
          <p>
            毎回人気なトートバッグ。今回もJMoF 2023限定デザインで登場！
            <br />
            グッズの持ち運びやキャラの装備品にいかがですか？
          </p>
          <p>サイズ：約W360 × H370 × D110 mm</p>
        </>
      ),
      en: (
        <>
          <p>
            Carry your stuff around safely in our ever-popular tote bag.
            <br />
            As in previous years, it’s available in the original JMoF design
            2023 edition!
          </p>
          <p>Size: W360 x L370 x D110 mm</p>
        </>
      ),
    },
    price: 2300,
    image: "JMF23_RG_goods_6.png",
  },
  {
    title: {
      ja: "JMoF 2023 オリジナルフェイスタオル",
      en: "JMoF 2023 Original Face Towel",
    },
    description: {
      ja: (
        <>
          <p>
            前回初めてラインナップして好評を博したフェイスタオル、今回もご用意しました！
            <br />
            1色刷りのシンプルなカラーリングで、お値段はお手頃価格に。お土産にもオススメです！
          </p>
        </>
      ),
      en: (
        <>
          <p>
            The face towel, one of the new products last time, and you guys
            ripped its bunch of stocks from our paws, is available again this
            year!
            <br />A simple single-color print for a reasonable price. We
            recommend them as souvenirs!
          </p>
        </>
      ),
    },
    price: 1000,
    image: "JMF23_RG_goods_7.png",
  },
  {
    title: {
      ja: "JMoF 2023 ネックストラップ",
      en: "JMoF 2023 Lanyard",
    },
    description: {
      ja: (
        <>
          <p>
            毎回恒例のネックストラップ。今回はシックでお洒落な色合いになりました！
            <br />
            ネームタグに使うもよし、着ぐるみのファスナーに使うもよし、お土産にもよし、まさにマストバイアイテム！
          </p>
        </>
      ),
      en: (
        <>
          <p>
            Every year, we produce a new JMoF-themed lanyard. This time it comes
            in chic and stylish colors!
            <br />
            Whether you use it for your name tag, as decoration for your
            fursuit, or give it to a friend as a souvenir, it is truly a
            must-have for JMoF attendees!
          </p>
        </>
      ),
    },
    price: 800,
    image: "JMF23_RG_goods_8.png",
  },
  {
    title: {
      ja: "JMoF 2023 ピンバッジ",
      en: "JMoF 2023 Pin Badge",
    },
    description: {
      ja: (
        <>
          <p>
            今回のピンバッジはロゴデザインを前面に押し出した疾走感のある仕上がり！
            <br />
            小さいワンポイントアイテムとして、通年のコレクションとしてもどうぞ。
          </p>
        </>
      ),
      en: (
        <>
          <p>
            This year, the design of our pin badge gives off a sense of speed!
            <br />
            Perfect as a small item to add to your collection.
          </p>
        </>
      ),
    },
    price: 700,
    image: "JMF23_RG_goods_9.png",
  },
  {
    title: {
      ja: "クリアファイル",
      en: "JMoF File Folder",
    },
    description: {
      ja: "これまでありそうでなかったグッズの定番。使いやすいA4サイズ！",
      en:
        "The standard piece of merchandise in Japan and yet we never sold it before. Easy-to-use A4 size to tame wild paper sheets.",
    },
    price: 300,
    image: "JMF23_RG_goods_10.png",
  },
  {
    title: {
      ja: "JMoF 2023 ステッカー",
      en: "JMoF 2023 Sticker",
    },
    description: {
      ja:
        "JMoFロゴに新たなカッコかわいいデザインが加わったステッカー。気になるものに貼り付ければ気分は毎日JMoF！！",
      en:
        "Sticker with a new cool-n-cute design combined with the JMoF logo. Put it on anything you care about and you’ll feel JMoFantastic every day!",
    },
    price: 300,
    image: "JMF23_RG_goods_11.png",
  },
  {
    title: {
      ja: "JMoF 2023 ポスター",
      en: "JMoF 2023 Poster",
    },
    description: {
      ja: (
        <>
          <p>
            今回のポスターは過去のテーマから時を越えたコラボレーション！
            <br />
            持ち帰り用ケースもご用意します。
          </p>
          <p>サイズ：B2</p>
        </>
      ),
      en: (
        <>
          <p>
            Get nostalgic with a poster that features a design compilation of
            past JMoF themes!
            <br />
            Poster cases to carry it are available as well.
          </p>
          Size: JIS B2<p></p>
        </>
      ),
    },
    price: 300,
    image: "JMF23_RG_goods_12.png",
  },
]

// 過去グッズ
const oldItems: (Omit<ItemProps, "image"> & { image: string })[] = [
  {
    title: {
      ja: "JMoFオリジナルボールペン（SARASA）",
      en: "JMoF Original Ballpoint Pen (SARASA)",
    },
    description: {
      ja:
        "お絵描きでも普段使いでも、何気ない日常にJMoFの思い出をちょっと思い起こさせてくれるボールペンです。",
      en:
        "Whether for drawing or regular use, it’s a pen that can help bring out a teeny memory of JMoF on a normal day.",
    },
    price: 200,
    image: "JMF22_RG_goods_1.png",
  },
  {
    title: {
      ja: "七匹の侍 フェイスタオル",
      en: "The Seven Samurai Face Towel",
    },
    description: {
      ja:
        "JMoF公式グッズに使いやすいフェイスタオルがついにラインアップしました！",
      en:
        "A face towel that’s easy to use has finally made its way to the JMoF Official Goods line-up!",
    },
    price: 1500,
    image: "JMF22_RG_goods_2.png",
  },
  {
    title: {
      ja: "七匹の侍 扇子",
      en: "The Seven Samurai Folding Fan",
    },
    description: {
      ja: (
        <>
          <p>
            {/* eslint-disable no-irregular-whitespace */}
            和風小物の大定番！　使ってヨシ、飾ってヨシ！
            {/* eslint-enable no-irregular-whitespace */}
            <br />
            急に大喜利が始まってもこれで安心。
          </p>
          <p>
            サイズ：7寸30間
            <br />
            仕様：フルカラー布貼り、箱・収納袋付属、携帯に嬉しい房付き
          </p>
        </>
      ),
      en: (
        <>
          <p>
            The standard Japanese-style accessory! Using it is great, hanging it
            is also great!
            <br />
            Banging it on the table, too, is great!
          </p>
          <p>
            Size: About 21cm, 30 ridges
            <br />
            Features: Full color cloth wrap, box and storage bag included, a
            tassel perfect for carriage included
          </p>
        </>
      ),
    },
    price: 3500,
    image: "JMF22_RG_goods_3.png",
  },
  {
    title: {
      ja: "七匹の侍 オリジナルモバイルブースター",
      en: "The Seven Samurai Original Mobile Charger",
    },
    description: {
      ja: (
        <>
          <p>
            素敵なイラストが入ったモバイルブースター。スマホの予備バッテリーや着ぐるみ着用時の空冷ファン用にお使いいただけます。
            <br />
            お部屋に飾ってもよい一品です。
          </p>
          <p>
            サイズ：約H99 × W63 × D14 mm
            <br />
            容量：5,000 ｍAh
          </p>
        </>
      ),
      en: (
        <>
          <p>
            A mobile charger with a wonderful art on the cover. You can use it
            as a backup battery for your smartphone or for the cooling fan when
            fursuiting.
            <br />
            It’s a product that can be displayed in your room as well.
          </p>
          <p>
            Size: About 99 mm height, 63 mm width, 14 mm depth
            <br />
            Capacity: 5,000 mAh
          </p>
        </>
      ),
    },
    price: 3000,
    image: "JMF22_RG_goods_4.png",
  },
  {
    title: {
      ja: "JMoF 2022 公式Tシャツ",
      en: "JMoF 2022 Official T-Shirt",
    },
    description: {
      ja: (
        <>
          <p>
            定番のJMoF公式Tシャツ。今回のイラストは昨年のオンライン販売に引き続きぐる（Grrr）様に描いていただきました！
          </p>
          <p>サイズ：S/M/L/XL/XXL/XXXL</p>
        </>
      ),
      en: (
        <>
          <p>
            The standard JMoF Official T-Shirt. This time’s art was drawn for us
            by Grrr, artist for the last year’s online shop.
          </p>
          <p>Size: S/M/L/XL/XXL/XXXL</p>
        </>
      ),
    },
    price: 2500,
    image: "JMF22_RG_goods_5.png",
  },
  {
    title: {
      ja: "JMoF 2022 トートバッグ",
      en: "JMoF 2022 Tote Bag",
    },
    description: {
      ja: (
        <>
          <p>
            同人誌やスケブ、ボドゲといった大きめの荷物を持ち歩ける、頑丈でカッコいいトートバッグ。
            <br />
            エコバッグとしてもご利用できます。
          </p>
          <p>
            サイズ：W360 × H370 × D110 mm
            <br />
            容量：約10 L<br />
            材質：コットン、ポリエステル
          </p>
        </>
      ),
      en: (
        <>
          <p>
            A durable and cool tote bag that lets you carry around your largish
            items, like fanbooks, sketchbooks, and boardgames.
            <br />
            You can use it as a bag for groceries too.
          </p>
          <p>
            Size: 360 mm width, 370 mm height, 110 mm depth
            <br />
            Capactiy: About 10 L<br />
            Materials: Cotton, Polyester
          </p>
        </>
      ),
    },
    price: 1500,
    image: "JMF22_RG_goods_6.png",
  },
  {
    title: {
      ja: "JMoF 2022 ピンバッジ",
      en: "JMoF 2022 Pin Badge",
    },
    description: {
      ja: (
        <>
          <p>毎度お馴染みのピンバッジ。今回もご用意しております！</p>
          <p>
            サイズ：⌀25 mm
            <br />
            カラー：シルバー
          </p>
        </>
      ),
      en: (
        <>
          <p>
            The familiar pin badge, present every time. We’re preparing them
            this time too!
          </p>
          <p>
            Size: ⌀ 25 mm
            <br />
            Color: Silver
          </p>
        </>
      ),
    },
    price: 600,
    image: "JMF22_RG_goods_7.png",
  },
  {
    title: {
      ja: "JMoF 2022 ステッカー",
      en: "JMoF 2022 Sticker",
    },
    description: {
      ja:
        "JMoFデザインのステッカー。スーツケースやお車に貼り付けてFURRYを演出しよう！",
      en:
        "JMoF Design Sticker. Stick it to something like your suitcase or car and show off your FURRY!",
    },
    price: 300,
    image: "JMF22_RG_goods_8.png",
  },
  {
    title: {
      ja: "JMoF 2022 ポスター",
      en: "JMoF 2022 Poster",
    },
    description: {
      ja: (
        <>
          <p>
            その回のJMoFテーマを象徴する大迫力のポスター。JMoFの思い出を飾ろう。
          </p>
          <p>サイズ：B2</p>
        </>
      ),
      en: (
        <>
          <p>
            A powerful poster featuring this time’s JMoF theme. Let’s decorate
            your room with a JMoF memory.
          </p>
          <p>Size: JIS B2</p>
        </>
      ),
    },
    price: 300,
    image: "JMF22_RG_goods_9.png",
  },
]

const GoodsList: FC = () => {
  const {
    i18n: { language },
  } = useTranslation()
  const images = useStaticQuery<GatsbyTypes.GoodsImagesQuery>(graphql`
    query GoodsImages {
      images: allFile(filter: { relativePath: { regex: "$/store/new/" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 450, maxHeight: 450) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      oldImages: allFile(filter: { relativePath: { regex: "$/store/old/" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 450, maxHeight: 450) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <div className={classes.Wrapper}>
        {items.map(item => (
          <Item
            key={item.title.ja}
            {...item}
            image={
              images.images.edges.find(edge =>
                edge.node.relativePath.endsWith(item.image)
              )?.node.childImageSharp?.fluid
            }
          />
        ))}
      </div>
      <h3>
        {language === "ja" ? "過去のグッズ" : "Previous Year’s JMoF Goods"}
      </h3>
      <div className={classes.Wrapper}>
        {oldItems.map(item => (
          <Item
            key={item.title.ja}
            {...item}
            image={
              images.oldImages.edges.find(edge =>
                edge.node.relativePath.endsWith(item.image)
              )?.node.childImageSharp?.fluid
            }
          />
        ))}
      </div>
    </>
  )
}
export default GoodsList
